// sessionSurface.js — discrimina a SUPERFÍCIE de uma sessão: aba Chat vs aba Code.
//
// Fonte de verdade: o campo `kind` de 1ª classe (Worker migration 0097 —
// 'chat' | 'code'). Antes disso a separação era derivada de (scope, mode), mas
// isso classifica errado: o Code tab também cria scope='local' + mode='direct'
// (pasta local não-git → CodeComposer força 'direct'). Por isso o `kind` existe.
//
// Fallback pra linhas SEM kind (otimistas criadas no cliente antes da resposta do
// server, ou criadas por um Worker antigo durante a transição de deploy): mantém o
// heurístico legado (local+direct = chat). Some assim que o server devolve `kind`.

export function sessionSurface(s) {
  if (!s || typeof s !== 'object') return 'code';
  if (s.kind === 'chat' || s.kind === 'code') return s.kind;
  return (s.scope || 'local') === 'local' && s.mode === 'direct' ? 'chat' : 'code';
}

/** true se a sessão pertence à aba Chat. */
export function isChatSession(s) {
  return sessionSurface(s) === 'chat';
}

/** true se a sessão pertence à aba Code. */
export function isCodeSession(s) {
  return sessionSurface(s) === 'code';
}
